import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={16.812}
    height={25.845}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 8400 12913"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974620199792">
        <path
          d="m8315 11291-922 1622H6243l452-1622zM7746 7910l654 3031H6722l-271-3031zM6143 11291l-452 1622H4564v-1622zM5910 7910l272 3031H4564V7910zM3836 11291v1622H2674l-451-1622zM2122 12913H992L82 11291h1588zM1915 7910l-272 3031H0l655-3031zM3836 7910v3031H2183l273-3031z"
          className="fil0"
        />
        <path
          d="M3870 72h661v8065h-661z"
          style={{
            // fill: "#1c1b17",
            // stroke: "#2b2a29",
            strokeWidth: 143.901,
          }}
          className="fill"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
